import {EnrollmentSequenceItem} from "../Sequence/EnrollmentSequence";
import {Button} from "react-bootstrap";

export type ProgressButtonProps = {
    sequenceItem: EnrollmentSequenceItem,
    controlId: string,
    selected: boolean,
    current: boolean,
    onClick(componentName: string): void
};


const ProgressButton = (props: ProgressButtonProps) => {
    const variant = props.selected ? "success" : "secondary";
    const disabled = !props.selected;

    const handleClick = () => {
        if(!props.selected){
            return;
        }
        props.onClick(props.sequenceItem.component.name);
    }
    
    const bold = props.current ? "fw-bold" : "";

    return (
        <Button aria-current={props.current ? 'page' : 'false'}   onClick={handleClick} id={props.controlId} disabled={disabled} variant={variant} className={`btn-progress ${bold}`}>
            <div>
                {props.selected && !props.current ? (<span className="sr-only">Completed Step</span>) : null}
                {props.sequenceItem.component.display}
            </div>
        </Button>
    );
}
ProgressButton.defaultProps = {
    selected: false
}
export default ProgressButton;